import React from 'react';
import { Card, CardBody, CardFooter } from '@nextui-org/react';
import Button from '../Button/Button';
import { message } from 'antd';
import { useSelector } from 'react-redux';
import { decryptData } from '../../utils/encryptData';
import { useNavigate } from 'react-router-dom';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';

function UpcomingCard({
  id,
  imageSrc,
  altText,
  title,
  presenter,
  description,
  language,
  category,
  date,
  startTime,
  endTime,
  url,
}) {
  const [isVerified, setIsVerified] = React.useState(false);
  const navigate = useNavigate();

  const { isAuthenticated, rl } = useSelector((state) => state.auth); // get role and isAuthenticated from redux state

  const decryptRole = decryptData(rl); // decrypt role

  const handleJoinToSession = async () => {
    if (decryptRole === 'editor') {
      message.warning('You do not have permission to access.');
      return;
    }

    if (
      !isAuthenticated ||
      (decryptRole !== 'admin' && decryptRole !== 'user')
    ) {
      message.warning(
        'Please register and verify account to join the session!'
      );
      navigate('/register');
      return;
    }

    const verifyStatus = await isVerifyCheck();

    if (!verifyStatus) {
      message.warning('Please verify your account to join the session!');
      return;
    }

    // If authenticated and has a valid email, navigate to the session video
    const type = true;
    navigate(`/session/video/${id}/${type}`);
  };

  const isVerifyCheck = async () => {
    let verifyStatus = false;

    try {
      const res = await PrivateAxiosInstance.get(URLs.CHECK_USER_VERIFIED_URL);
      verifyStatus = res.data?.user?.['custom:Verify'];
    } catch (err) {
      console.error('user verify error: ', err);
    }

    if (verifyStatus != 'verified') {
      verifyStatus = false;
    } else {
      verifyStatus = true;
    }
    return verifyStatus;
  };

  return (
    <>
      <Card isPressable className="ml-10 sm:ml-3">
        <CardBody>
          <img
            className="min-h-[100px] max-h-[330px] rounded-lg w-full font-poppins object-cover"
            src={imageSrc}
            alt={altText}
          />

          <div className="gap-5">
            <h3 className="text-lg md:text-2xl font-bold text-gray-300 font-poppins mt-3 line-clamp-3">
              {title}
            </h3>

            {/* presenetr */}
            <h5 className="text-btn-color text-paragraph-font-size font-medium capitalize font-poppins mt-3">
              {presenter}
            </h5>

            {/* language */}
            <p className="text-gray-400 font-poppins mt-1">
              Category: <span className="text-gray-400">{category}</span>
            </p>

            {/* language */}
            <p className="text-gray-400 font-poppins mt-1">
              Language: <span className="text-gray-400">{language}</span>
            </p>

            {/* Time */}
            <p className="text-gray-400 font-poppins mt-1">
              Time:{' '}
              <span className="text-gray-400">
                {startTime} - {endTime}
              </span>
            </p>

            {/* session url */}
            {/* <p className="text-gray-400 font-poppins mt-1">
              Session Url: <span className="text-gray-400">{url}</span>
            </p> */}

            {/* description */}
            <p className="mt-3 text-paragraph-font-size font-medium text-gray-400 font-poppins leading-relaxed line-clamp-4">
              {description}
            </p>

            <div className="flex justify-end items-center min-w-[200px] mt-[-10px] md:mb-[-10px]">
              <Button onClick={handleJoinToSession} label={'Register now'} />
            </div>
          </div>
        </CardBody>
        <CardFooter></CardFooter>
      </Card>
    </>
  );
}

export default UpcomingCard;
